import { Button } from '@ace-clublabs/shared-component-library';

interface SearchButtonProps {
  onClick?: () => void;
  loading?: boolean;
}

const SearchButton: React.FC<SearchButtonProps> = ({ onClick, loading }) => {
  return (
    <Button
      label='Search'
      onClick={onClick}
      variant='contained'
      data-testid='search-button'
      loading={loading}
      sx={{
        height: 40,
      }}
    />
  );
};

export default SearchButton;
